import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import PostView from './components/PostView';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import NotFound from './components/NotFound';
import CategoryList from './components/CategoryList';
import './styles/main.css';

const App = () => {
  // State to track authentication
  const [isAuth, setIsAuth] = useState(localStorage.getItem('authToken') !== null);

  // Check if user is authenticated
  const isAuthenticated = () => {
    return isAuth || localStorage.getItem('authToken') !== null;
  };

  // Handle successful login
  const handleLogin = () => {
    setIsAuth(true);
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setIsAuth(false);
  };

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/post/:id" element={<PostView />} />
      <Route path="/categories" element={<CategoryList />} />
      <Route path="/categories/:category" element={<HomePage />} />
      <Route path="/tags/:tag" element={<HomePage />} />
      <Route path="/archive" element={<HomePage />} />
      <Route path="/about" element={<HomePage />} />
      <Route 
        path="/login" 
        element={isAuthenticated() ? <Navigate to="/admin" /> : <AdminLogin onLogin={handleLogin} />} 
      />
      <Route 
        path="/admin" 
        element={isAuthenticated() ? <AdminDashboard onLogout={handleLogout} /> : <Navigate to="/login" />} 
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
